import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const RoundedSquare = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="68" viewBox="0 0 68 69" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M57.7238 0.719681H10.4C4.87715 0.719681 0.399994 5.19684 0.399994 10.7197V58.0435C0.399994 63.5664 4.87715 68.0435 10.4 68.0435H57.7238C63.2467 68.0435 67.7238 63.5663 67.7238 58.0435V10.7197C67.7238 5.19683 63.2467 0.719681 57.7238 0.719681Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
